export enum EnumAttachmentType {
  PDF = 'pdf',
  EXCEL = 'excel',
  POWERPOINT = 'powerpoint',
  WORD = 'word',
  IMAGE = 'image',
  TEXT = 'text',
  GENERIC = 'generic',
}
